import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleNike() {
  const article = seoArticles.find((a) => a.slug === "kakobuy-spreadsheet-nike-najlepsze-produkty")!;
  return <ArticleLayout article={article} />;
}